import { Inject, Injectable } from '@angular/core';

import { LOCAL_STORAGE } from '@app/modules/core/tokens/app.tokens';
import { LocalStorage } from '@app/modules/core/interfaces/local-storage';
import { decodeURLParams, encodeURLParams } from '@packages/packages-result/mappers/package-routing.mapper';
import {
  AIR_SELECTED, PACKAGE_BASE_URL_RESULT, RATE_ID, SEARCH_PK
} from '@packages/packages-search-bar/constants/package-flux-params';
import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';
import { FlightResultDesktop } from '@app/entities/flight-results';
import { PackageSeachResponse } from '@packages/packages-result/entities/packages-search';

@Injectable()
export class LocalStorageService {

  constructor(
    @Inject(LOCAL_STORAGE) private localStorage: LocalStorage
  ) { }

  public getDecodePackageAirSelected(): string {
    return decodeURLParams(this.localStorage.getItem(AIR_SELECTED));
  }

  public setEncodePackageAirSelected(airSelected: AirResultOptionResponse | FlightResultDesktop): void {
    this.localStorage.setItem(AIR_SELECTED, encodeURLParams(JSON.stringify(airSelected)));
  }

  public getDecodePackageSearch(): string {
    return decodeURLParams(this.localStorage.getItem(SEARCH_PK));
  }

  public setEncodePackageSearch(search: PackageSeachResponse): void {
    this.localStorage.setItem(SEARCH_PK, encodeURLParams(JSON.stringify(search)));
  }

  public getDecodePackageRateHotelId(): string {
    return decodeURLParams(this.localStorage.getItem(RATE_ID));
  }

  public setEncodePackageRateHotelId(rateId: string): void {
    const encode = encodeURLParams(rateId);
    this.localStorage.setItem(RATE_ID, encode);
  }

  public getDecodePackageBaseUrlResult(): string {
    return decodeURLParams(this.localStorage.getItem(PACKAGE_BASE_URL_RESULT));
  }

  public setEncodePackageBaseUrlResult(url: string): void {
    const encode = encodeURLParams(url);
    this.localStorage.setItem(PACKAGE_BASE_URL_RESULT, encode);
  }

  public removeAllPackageData(): void {
    this.localStorage.removeItem(AIR_SELECTED);
    this.localStorage.removeItem(SEARCH_PK);
    this.localStorage.removeItem(RATE_ID);
    this.localStorage.removeItem(PACKAGE_BASE_URL_RESULT);
  }


}
